import './Prototypes/index';
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import thunk from 'redux-thunk'
import app from './reducers'
import { historyMiddleware } from './Middlewares/History.middleware'
import ReadMoreScroll from "./Shared/ReadMoreScroll";
import "./HaboCustom/Vanilla/CustomVideo";
import ScrollContainerInitializer from "./HaboCustom/ScrollContainer";
import QuickSearchContainer from './Containers/QuickSearch.container'
import NavigationContainer from './Containers/Navigation.container'
import FacetedSearchContainer from './HaboCustom/Containers/FacetedSearch.container'
import FacetedSearchCompactContainer from './HaboCustom/Containers/FacetedSearchCompact.container'
import NotificationContainer from './Containers/Notification.container'
import DynamicComponent from './Components/DynamicComponent'
import ItemScroll from './Components/ItemScroll'
import ResellerGoogleMapContainer from "./Containers/ResellerGoogleMap.container"
import VariantChooser from "./Containers/VariantChooser.container"
import { trackCheckout, trackPurchase, trackViewItem } from './Shared/Tracking';
import './Shared/SearchOtherHitsShowMore';
import DeveloperTools from "./Shared/dev";
import MiscellaneousMenu from "./Components/MiscellaneousMenu";
import CategoryNavigation from "./HaboCustom/Vanilla/CategoryNavigation";
import { InitializeHeroWrapperHandler } from "./Shared/HeroWrapperMediaHandler";
import MobileFilterTrigger from "./HaboCustom/Components/MobileFilterTrigger";

document.addEventListener('DOMContentLoaded', () => {
    new DeveloperTools();
    new InitializeHeroWrapperHandler();
});

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = window.__litium.store = window.__litium.store || (window.parent.__litium && window.parent.__litium.store)
    || createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));
// register redux's actions so we can invoke them from vanilla JS
// usage: window.__litium.reduxActions.addToCart(...);
window.__litium = {
    ...window.__litium,
    tracking: {
        trackViewItem,
        trackCheckout,
        trackPurchase
    },
    onSearchResultDataChange: dom => {
        let temp = document.createElement('div')
        temp.innerHTML = dom
        const currentResult = document.querySelector('#search-result')
        const newResult = temp.querySelector('#search-result')
        //move facetSearchCompact from currentResult to newResult
        newResult.replaceChild(
            currentResult.querySelector('#facetedSearchCompact'),
            newResult.querySelector('#facetedSearchCompact')
        )
        //replace currentResult with newResult
        currentResult.parentNode.replaceChild(newResult, currentResult)
    },
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};

const bootstrapComponents = () => {
    let productPageBuyButtonsEl = document.querySelectorAll('.product-page-buy-buttons');
    if (productPageBuyButtonsEl.length) {
        const ProductPageBuyButtons = DynamicComponent({
            loader: () => import('./Containers/ProductPageBuyButtons.container')
        });
        productPageBuyButtonsEl.forEach((buyButtonsEl) => {
            ReactDOM.render(
                <Provider store={store}>
                    <ProductPageBuyButtons
                        isMuurikka={!!+buyButtonsEl.dataset.isMuurikka}
                        isProductPage={!!+buyButtonsEl.dataset.isProductPage}
                        productItem={JSON.parse(buyButtonsEl.dataset.productItem)}
                    />
                </Provider>,
                buyButtonsEl
            );
        });
    }

    if (document.getElementById('quick-search')) {
        ReactDOM.render(
            <Provider store={store}>
                <QuickSearchContainer isMuurikka={false} />
            </Provider>,
            document.getElementById('quick-search')
        );
    }

    if (document.getElementById('navbar')) {
        ReactDOM.render(
            <Provider store={store}>
                <NavigationContainer/>
            </Provider>,
            document.getElementById('navbar')
        );
    }

    if (document.getElementById('filter-wrapper__trigger')) {
        ReactDOM.render(
            <Provider store={store}>
                <MobileFilterTrigger />
            </Provider>,
            document.getElementById('filter-wrapper__trigger')
        );
    }

    if (document.getElementById('facetedSearch')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchContainer/>
            </Provider>,
            document.getElementById('facetedSearch')
        );
    }

    if (document.getElementById('facetedSearchCompact')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchCompactContainer/>
            </Provider>,
            document.getElementById('facetedSearchCompact')
        );
    }

    if (document.getElementById('globalNotification')) {
        ReactDOM.render(
            <Provider store={store}>
                <NotificationContainer/>
            </Provider>,
            document.getElementById('globalNotification')
        );
    }

    let itemScrollElements = document.querySelectorAll('.item-scroll__inner');
    if (itemScrollElements.length) {
        itemScrollElements.forEach((element) => {
            let templates = element.querySelectorAll('template');
            const values = [...templates].map((template) => {
                return { html: template.innerHTML, className: template.dataset.classes || '' }
            });

            ReactDOM.render(
                <ItemScroll items={values} />,
                element
            )
        })
    }

    if (document.getElementById('myPagePersons')) {
        const PersonList = DynamicComponent({
            loader: () => import('./Containers/PersonList.container')
        });

        ReactDOM.render(
            <Provider store={store}>
                <PersonList/>
            </Provider>,
            document.getElementById('myPagePersons')
        );
    }

    if (document.getElementById('myPageAddresses')) {
        const AddressList = DynamicComponent({
            loader: () => import('./Containers/AddressList.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <AddressList/>
            </Provider>,
            document.getElementById('myPageAddresses')
        );
    }

    if (document.getElementById('checkout')) {
        const Checkout = DynamicComponent({
            loader: () => import('./Containers/Checkout.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <Checkout/>
            </Provider>,
            document.getElementById('checkout')
        );
    }

    if (document.getElementById('lightBoxImages')) {
        const LightboxImages = DynamicComponent({
            loader: () => import('./Containers/LightboxImages.container')
        });

        const rootElement = document.getElementById('lightBoxImages');
        let mediaItems = Array.from(rootElement.querySelectorAll('a')).map(anchor => {
            return {
                fullSrc: anchor.dataset.src,
                previewSrc: anchor.dataset.previewSrc,
                thumbnailSrc: anchor.dataset.thumbnailSrc,
                type: anchor.dataset.type,
                alt: anchor.dataset.alt || '',
                mimeType: anchor.dataset.mime,
            }
        });

        const productLabelsTemplate = rootElement.querySelector('#product-labels-template');
        const productLabelsHtml = productLabelsTemplate && productLabelsTemplate.innerHTML;

        ReactDOM.render(
            <Provider store={store}>
                <LightboxImages mediaItems={mediaItems} productLabelsHtml={productLabelsHtml}/>
            </Provider>,
            rootElement
        );
    }

    if (document.querySelectorAll('.image-video-lightbox')) {
        const ImageVideoLightbox = DynamicComponent({
            loader: () => import('./Components/ImageVideoLightbox')
        });

        const rootElements = document.querySelectorAll('.image-video-lightbox');

        if (rootElements.length) {
            rootElements.forEach(function(element) {
                if (!element) return;
                let data = JSON.parse(element.dataset.json);

                ReactDOM.render(
                    <Provider store={store}>
                        <ImageVideoLightbox data={data}/>
                    </Provider>,
                    element
                );
            })
        }
    }

    if (document.querySelectorAll('.slider').length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Components/Slider')
        });
        Array.from(document.querySelectorAll('.slider')).forEach((slider, index) => {
            const values = [...slider.querySelectorAll('.slider__block')].map(block => {
                return ({
                    image: block.dataset.image,
                    url: block.dataset.url,
                    text: block.dataset.text,
                })
            });
            if (values.length > 0) {
                ReactDOM.render(
                    <Slider values={values}/>,
                    slider
                );
            }
        });
    }

    if (document.querySelectorAll('buy-button').length > 0) {
        const BuyButton = DynamicComponent({
            loader: () => import('./Containers/BuyButton.container')
        });
        Array.from(document.querySelectorAll('buy-button')).forEach((button) => {
            const {articleNumber, quantityFieldId, href, cssClass} = button.dataset;
            const label = button.innerText;
            ReactDOM.render(
                <Provider store={store}>
                    <BuyButton {...{label, articleNumber, quantityFieldId, href, cssClass}} />
                </Provider>,
                button
            );
        });
    }

    if (document.querySelectorAll('reorder-button').length > 0) {
        const ReorderButton = DynamicComponent({
            loader: () => import('./Containers/ReorderButton.container')
        });
        Array.from(document.querySelectorAll('reorder-button')).forEach((button) => {
            const {cssClass, orderId, title} = button.dataset;
            const label = button.innerText;
            ReactDOM.render(
                <Provider store={store}>
                    <ReorderButton {...{label, title, cssClass, orderId}} />
                </Provider>,
                button
            );
        });
    }

    if (document.getElementById('resellerGoogleMap')) {
        ReactDOM.render(
            <Provider store={store}>
                <ResellerGoogleMapContainer/>
            </Provider>,
            document.getElementById('resellerGoogleMap')
        )
    }

    //  if (document.getElementById('ResellerGoogleMapForProduct')) {
    //   ReactDOM.render(
    //     <Provider store={store}>
    //       <ResellerGoogleMapForProductContainer />
    //     </Provider>,
    //     document.getElementById('ResellerGoogleMapForProduct')
    //   )
    // }

    if (document.getElementById('variantChooser')) {
        ReactDOM.render(
            <Provider store={store}>
                <VariantChooser/>
            </Provider>,
            document.getElementById('variantChooser')
        )
    }

    let resellerProductEls = document.querySelectorAll('.reseller-product');
    if (resellerProductEls.length) {
        const ResellerProduct = DynamicComponent({
            loader: () => import('./Containers/ResellerGoogleMapForProduct.container')
        });
        resellerProductEls.forEach((resellerProduct) => {
            ReactDOM.render(
                <Provider store={store}>
                    <ResellerProduct
                        variantId={resellerProduct.dataset.variantId}
                        isGlobalChannel={resellerProduct.dataset.isglobalchannel}
                    />
                </Provider>,
                resellerProduct
            );
        });
    }

    if (document.getElementById('miscellaneous-menu-btn')) {
        ReactDOM.render(
            <Provider store={store}>
                <MiscellaneousMenu />
            </Provider>,
            document.getElementById('miscellaneous-menu-btn')
        )
    }

    let findResellerStoresButtons = document.querySelectorAll('.find-reseller-stores-button');
    if (findResellerStoresButtons.length) {
        const FindResellerStoresButton = DynamicComponent({
            loader: () => import('./Containers/FindResellerStoresButton.container')
        });
        findResellerStoresButtons.forEach((findResellerButton) => {
            ReactDOM.render(
                <Provider store={store}>
                    <FindResellerStoresButton isMuurikka={!!+findResellerButton.dataset.isMuurikka} />
                </Provider>,
                findResellerButton
            );
        });
    }

    //Collage
    if (document.querySelectorAll('.collage')) {
        let buttons = document.querySelectorAll('.collage .collage-button img');

        if (buttons.length) {
            [].forEach.call(buttons, el => {
                el.addEventListener('click', function (event) {
                    // Stop click on a-tag.
                    event.stopPropagation();
                    event.preventDefault();
                    this.parentNode.previousElementSibling.classList.toggle('hidden');
                    this.parentNode.classList.toggle('close-button');
                });
            });
        }

        let textboxes = document.querySelectorAll('.collage .collage-text');
        if (textboxes.length) {
            [].forEach.call(textboxes, el => {
                el.addEventListener('click', function (event) {
                    // Stop click on a-tag.
                    event.stopPropagation();
                    event.preventDefault();
                    this.nextElementSibling.classList.toggle('close-button');
                    this.classList.toggle('hidden');
                });
            });
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        let breadcrumb = document.querySelector('#breadcrumbs-container .breadcrumbs');
        if (breadcrumb) {
            breadcrumb.scrollLeft = breadcrumb.scrollWidth;
            breadcrumb.style.visibility = 'visible';
        }

        let breadcrumbsContainer = document.querySelector('#breadcrumbs-container');
        if (breadcrumbsContainer && !breadcrumbsContainer.closest('.second-header') && !breadcrumbsContainer.closest('.second-header--mobile')) {
            breadcrumbsContainer.classList.add('no-second-header');
        }
    });

    new ReadMoreScroll();
    new CategoryNavigation();
    new ScrollContainerInitializer();
}

bootstrapComponents();
